import { useState } from 'react'
import { Card, FormControl, Form } from 'react-bootstrap'
import v from '../validators'
import { t } from '../locale'
import KButton from '../components/KButton'
import { DoorOpenFill } from 'react-bootstrap-icons'
import { useNavigate } from 'react-router-dom'

function ForgotPassword() {
  const navigate = useNavigate()

  const [email, setEmail] = useState('')
  const [isEmailValid, setIsEmailValid] = useState(true)

  function sendPasswordResetEmail() {
    fetch(`${process.env.REACT_APP_API_URL}/access/password-reset-email`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
      }),
    })
      .then(r => r.json())
      .then(r => {
        if (r.ok) {
          navigate('/user/login')
        }
      })
  }

  function handleEmail(e: any) {
    setEmail(e.target.value.trim())
    setIsEmailValid(v.email(email))
  }
  function handleSubmit(e: any) {
    e.preventDefault()

    setIsEmailValid(v.email(email))

    if (v.email(email)) {
      sendPasswordResetEmail()
    }
  }

  return (
    <Card className='col-8 m-auto'>
      <Card.Header>
        <DoorOpenFill />
        <span className='p-1 align-middle' style={{ textTransform: 'none' }}>
          {t('getPasswordResetEmail')}
        </span>
      </Card.Header>

      <Card.Body>
        <Form onSubmit={handleSubmit}>
          <FormControl
            id='email'
            type='email'
            isInvalid={!isEmailValid}
            placeholder={t('email')}
            value={email}
            onChange={handleEmail}
            onKeyUp={handleEmail}
            autoComplete='on'
            autoFocus
          />

          <KButton
            type='submit'
            icon='send'
            variant='success'
            className='mt-3 text-white no-capitalize'
            style={{ textTransform: 'none' }}
            onclick={handleSubmit}
            label={t('sendLink')}
          />
        </Form>
      </Card.Body>
    </Card>
  )
}

export default ForgotPassword
